//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: [
    'icon',
    'buttonText',
    'confirmText',
  ],
  data() {
    return {
      backdropEl: null,
      isMobile: (('ontouchstart' in window) ||
                  (window.navigator.msMaxTouchPoints > 0)),
    };
  },
  computed: {
    isIconButton() {
      return !this.buttonText;
    }
  },
  methods: {
    showBackdrop() {
      if (!this.backdropEl) {
        this.backdropEl = document.createElement('div');
        this.backdropEl.classList.add('confirmed-action-menu-backdrop');
        document.body.appendChild(this.backdropEl);
      }
    },
    removeBackdrop() {
      if (this.backdropEl) {
        this.backdropEl.remove();
        this.backdropEl = null;
      }
    },
  },
  beforeDestroy() {
    this.removeBackdrop();
  },
};
